import { CustomerImportList } from '@/_types/models/customer-import-list';
import { _callBackend } from '../api';

export const getCustomerImportLists = async ({
  token,
}: {
  token: string;
}): Promise<{
  customer_import_lists?: Array<CustomerImportList>;
  error?: string;
}> => {
  return await _callBackend('/v2/customer_import_lists', 'GET', null, token);
};

export const deleteAllEntitiesInLastNHours = async ({
  token,
  hours,
  customer_import_list_id,
}: {
  token: string;
  hours: number;
  customer_import_list_id: string;
}): Promise<void> => {
  return await _callBackend(
    `/v2/customer_import_lists/delete_all_entities_in_last_n_hours?hours=${hours}&customer_import_list_id=${customer_import_list_id}`,
    'POST',
    null,
    token,
  );
};

export const importIndividualsFromClientList = async ({
  token,
  records,
  original_file_name,
  assigned_firm_user_id,
}: {
  token: string;
  records: string;
  original_file_name: string;
  assigned_firm_user_id?: string | number;
}): Promise<void> => {
  return await _callBackend(
    '/v2/customer_import_lists/import_individuals_from_client_list',
    'POST',
    {
      records,
      original_file_name,
      assigned_firm_user_id,
    },
    token,
  );
};

export const downloadImportList = async ({
  token,
  import_list_id,
}: {
  token: string;
  import_list_id: string;
}): Promise<{ document: { data: { link: string } } }> => {
  return await _callBackend(
    `/v2/customer_import_lists/${import_list_id}/download_import_list`,
    'POST',
    null,
    token,
  );
};
